import { firstValueFrom } from 'rxjs';
import type { PersonalSettingMap } from '@ardoq/api-types';
import { loadedCurrentUser$ } from './currentUser$';

/** Resolves once the current user has loaded; never resolves for anonymous users. */
export const getLoadedPersonalSetting = async <
  K extends keyof PersonalSettingMap,
>(
  personalSetting: K
): Promise<PersonalSettingMap[K] | undefined> =>
  (await firstValueFrom(loadedCurrentUser$)).settings[personalSetting];
